import type { TypeTableColumn } from '@thefarmersfront/kitchen';

export type TypeDeliveryOperationInfoRow = {
  inboundHub: string;
  inboundSchedule: string;
};

/**
 * [화주사 정보 관리 > 화주사 정보] '배송운영 정보' 테이블 컬럼 정의
 */
const getVenderConfirmDeliveryOperationInfoColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeDeliveryOperationInfoRow>[] = [
    {
      accessorKey: 'inboundHub',
      header: '입고Hub',
      size: 200,
    },
    {
      accessorKey: 'inboundSchedule',
      header: '입고 스케줄',
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getVenderConfirmDeliveryOperationInfoColumnDefs;
